import {useDevicesStore} from "entities/devices/model/store";
import {pluralize} from "shared/helpers/string";
import styled from "styled-components";
import {COLORS} from "shared/consts";
import {toRem} from "shared/helpers";

const DevicesTitleWrapper = styled.div`
    display: flex;
    align-items: baseline;
    gap: ${toRem(8)};
`;

const DevicesTitleText = styled.h1`
    margin: 0;
    font-size: ${toRem(24)};
    font-weight: 700;
    line-height: ${32 / 24};
    color: ${COLORS.FG.DEFAULT};
`;

const DevicesSubtitle = styled.span`
    font-size: ${toRem(14)};
    font-weight: 400;
    line-height: ${20 / 14};
    color: ${COLORS.FG.MUTED};
`;

export const DevicesTitle = () => {
    const devices = useDevicesStore((s) => s.allDevices);
    const devicesCount = devices.length;
    const deviceWord = pluralize(devicesCount, "устройство", "устройства", "устройств");

    return (
        <DevicesTitleWrapper>
            <DevicesTitleText>Управление устройствами</DevicesTitleText>
            <DevicesSubtitle>{devicesCount} {deviceWord}</DevicesSubtitle>
        </DevicesTitleWrapper>
    );
};

